import TimeTableDay from './TimeTableDay';
import TimeTableWeek from './TimeTableWeek';

export default {
  Day: TimeTableDay,
  Week: TimeTableWeek
};
